import { createFileRoute } from "@tanstack/react-router";
import { AssignmentsPage } from "@/components/features/FormBuilder/Assignments/AssignmentsPage/AssignmentsPage";

export const Route = createFileRoute("/form-builder/_formBuilderLayout/assignments/")({
  component: AssignmentsPage,
});
